import { render, staticRenderFns } from "./assistant.vue?vue&type=template&id=4052e335&scoped=true"
import script from "./assistant.vue?vue&type=script&lang=ts"
export * from "./assistant.vue?vue&type=script&lang=ts"
import style0 from "./assistant.vue?vue&type=style&index=0&id=4052e335&prod&lang=stylus&scoped=true"
import style1 from "./assistant.vue?vue&type=style&index=1&id=4052e335&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052e335",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VCol,VContainer,VLayout,VOverlay,VRow,VThemeProvider})
